import React from "react";
import { Link } from "react-router-dom";

// images
import heroImg from "../assets/portfolio-hero.png";

import web from "../assets/web.png";
import design from "../assets/design.png";
import seo from "../assets/seo.png";
import mobile from "../assets/mobile.png";
import software from "../assets/software.png";
import ecommerce from "../assets/ecommerce.png";
import ai from "../assets/ai.png";
import consulting from "../assets/consulting.png";
import data from "../assets/data.png";

// NEW SERVICES IMAGES (you will add these)
import graphic from "../assets/graphic.png";
import staff from "../assets/team.png";
import cyber from "../assets/security.png";
import marketing from "../assets/marketing.png";
import content from "../assets/content.png";
import aiIntegration from "../assets/ai2.png";

const Portfolio = () => {

  const services = [
    { title: "Web Development", img: web, link: "/services/web" },
    { title: "UI/UX Design", img: design, link: "/services/design" },
    { title: "SEO Optimization", img: seo, link: "/services/seo" },
    { title: "Mobile App Development", img: mobile, link: "/services/mobile" },
    { title: "Software Development", img: software, link: "/services/software" },
    { title: "E-commerce Solutions", img: ecommerce, link: "/services/ecommerce" },
    { title: "AI Automation", img: ai, link: "/services/ai" },
    { title: "IT Consulting", img: consulting, link: "/services/consulting" },
    { title: "AI & Data Solutions", img: data, link: "/services/data" },

    // 🔥 NEW ADDED SERVICES
    { title: "Graphic Design", img: graphic, link: "/services/graphic" },
    { title: "Staff Augmentation", img: staff, link: "/services/staff-augmentation" },
    { title: "Cybersecurity", img: cyber, link: "/services/cyber-security" },
    { title: "Digital Marketing", img: marketing, link: "/services/marketing" },
    { title: "Content Writing", img: content, link: "/services/content" },
    { title: "AI Integration", img: aiIntegration, link: "/services/ai-integration" },
  ];

  return (
    <div className="text-white">

      {/* ================= HERO ================= */}
      <section className="relative h-[90vh] flex items-center justify-center text-center overflow-hidden">

        {/* Background Image */}
        <img
          src={heroImg}
          alt="Portfolio Background"
          className="absolute inset-0 w-full h-full object-cover scale-105 animate-[slowZoom_20s_linear_infinite]"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/80"></div>

        {/* Glow */}
        <div className="absolute w-[500px] h-[500px] bg-purple-500/20 blur-3xl rounded-full top-10 left-10 animate-pulse"></div>
        <div className="absolute w-[400px] h-[400px] bg-pink-500/20 blur-3xl rounded-full bottom-10 right-10 animate-pulse"></div>

        <div className="relative z-10 px-6">
          <h1 className="text-5xl md:text-7xl font-bold">
            Our{" "}
            <span className="bg-gradient-to-r from-purple-400 to-pink-500 text-transparent bg-clip-text">
              Portfolio
            </span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto text-lg">
            We transform ideas into high-performing digital products that drive growth and success.
          </p>

          <div className="mt-8 flex justify-center gap-4 flex-wrap">
            <button className="px-8 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
              Explore Work
            </button>

            <Link to="/contact">
              <button className="px-8 py-3 border border-gray-400 rounded-lg hover:border-purple-400 transition">
                Start a Project
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* ================= SERVICES GRID ================= */}
      <section className="py-24 px-6 bg-[#0b1a35]">

        <h2 className="text-4xl font-bold text-center mb-16">
          Explore Our <span className="text-purple-400">Expertise</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">

          {services.map((service, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-[#112240] hover:-translate-y-2 transition"
            >
              <div className="relative">
                <img
                  src={service.img}
                  alt={service.title}
                  className="h-60 w-full object-cover group-hover:scale-110 transition duration-500"
                />
                <div className="absolute inset-0 bg-black/50"></div>
              </div>

              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold mb-4 group-hover:text-purple-400">
                  {service.title}
                </h3>

                <Link to={service.link}>
                  <button className="px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
                    View Details
                  </button>
                </Link>
              </div>
            </div>
          ))}

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-24 px-6 text-center bg-gradient-to-r from-purple-600 to-pink-500">

        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Let’s Build Something Amazing 🚀
        </h2>

        <p className="text-gray-100 mb-8">
          Your next big project starts here.
        </p>

        <div className="flex justify-center gap-4 flex-wrap">
          <Link to="/contact">
            <button className="bg-black px-8 py-3 rounded-lg hover:scale-105 transition">
              Contact Us
            </button>
          </Link>

          <Link to="/services">
            <button className="border border-white px-8 py-3 rounded-lg hover:bg-white hover:text-black transition">
              View Services
            </button>
          </Link>
        </div>

      </section>

    </div>
  );
};

export default Portfolio;